import { createOpenAICompatibleProvider } from "./openAICompatibleProvider";
import { groqCircuit } from "../../runtime/httpCircuitBreaker";

/**
 * Groq provider. Activates automatically when GROQ_API_KEY is set.
 * Uses Groq's OpenAI-compatible endpoint. Extreme throughput, ideal for small
 * edits, classification, and fast error correction.
 */
export const groqProvider = createOpenAICompatibleProvider({
  name: "groq",
  apiKeyEnv: "GROQ_API_KEY",
  baseURL: "https://api.groq.com/openai/v1",
  defaultModel: "llama-3.3-70b-versatile",
  circuit: groqCircuit,
  supportsJSON: true,
  supportsTools: true,
});
